import DodoneContext from 'app/dodones/Context'
import axios from 'axios'

export default ({ value, onChange }) => {
  const { dodone } = useContext(DodoneContext)
  const [comments, setComments] = useState([])

  useEffect(() => {
    axios
      .get(`api/dodones/${dodone.id}/comments.json`)
      .then(({ data }) => {
        setComments(data.comments)
      })
      .catch((e) => {
        console.log('Deu pau pra pegar os comments: ', e)
        return { error: true }
      })
  }, [dodone.id])

  const changed = useCallback((e) => {
    onChange(e.target.value)
  })

  const useComment = useCallback((e) => {
    onChange(e.target.innerText)
  })

  return (
    <>
      <textarea
        className="mb-d"
        placeholder="Comment"
        name="comment"
        value={value || ''}
        onChange={changed}
      />
      {Object.entries(comments).map(([index, comment]) => {
        return (
          <div
            className="text-sm text-blue-500 py-2 border-b-gray-100"
            onClick={useComment}
            key={index}
          >
            
            {comment}
          </div>
        )
      })}
    </>
  )
}
